import { type FC } from 'react';
import { useRefetchableFragment, graphql } from 'react-relay';
import { PdpRespMarketplaceLayoutSecondaryContextProvider } from './PdpRespMarketplaceLayoutSecondaryContext';
import { PdpRespMarketplaceContainerSecondary } from '../PdpRespMarketplaceContainer/PdpRespMarketplaceContainerSecondary';

// types
import { type PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer$key as Viewer } from './__generated__/PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer.graphql';
import { type pdpRespMarketplaceSecondaryRootQuery$variables as RelayVariables } from '../../../queries/pdpRespMarketplaceSecondaryRoot';

const viewerFragment = graphql`
    fragment PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer on Viewer
    @refetchable(queryName: "PdpRespMarketplaceLayoutSecondaryRefetchContainerQuery") {
        ...PdpRespMarketplaceContainerSecondary_viewer
        ...PdpRespMarketplaceLayoutSecondaryContextProvider_viewer
    }
`;

export const PdpRespMarketplaceLayoutSecondaryRefetchContainer: FC<{
    viewer: Viewer;
    relayVariables: RelayVariables;
}> = ({ viewer: viewerRef, relayVariables }) => {
    const [viewer, refetch] = useRefetchableFragment(viewerFragment, viewerRef);
    return (
        <PdpRespMarketplaceLayoutSecondaryContextProvider
            viewer={viewer}
            refetch={refetch}
            relayVariables={relayVariables}
        >
            <PdpRespMarketplaceContainerSecondary viewer={viewer} />
        </PdpRespMarketplaceLayoutSecondaryContextProvider>
    );
};
